import React from "react";
import GlobalMetricCards from "../../../../../global/GlobalMetricCards";

export default function ToAndFroDashboardMetricsSection({ stats, loadingStats }) {
  const items = [
    {
      key: "total-today",
      label: "Total Movements Today",
      value: stats?.total_today ?? 0,
      tone: "teal",
    },
    {
      key: "currently-outside",
      label: "Currently Outside",
      value: stats?.currently_out ?? 0,
      tone: "coral",
    },
    {
      key: "returned-today",
      label: "Returned Today",
      value: stats?.returned_today ?? 0,
      tone: "mint",
    },
    {
      key: "total-month",
      label: "Total Movements This Month",
      value: stats?.monthly_total ?? 0,
      tone: "slate",
    },
  ];

  return (
    <div
      id="tf-stats"
      className="user-builder-panel"
      style={{ scrollMarginTop: "2rem" }}
    >
      <div className="user-builder-panel__head">
        <h3 className="user-builder-panel__title">Performance overview</h3>
        <p className="user-builder-panel__hint">
          Live movement statistics and tracking.
        </p>
      </div>
      <GlobalMetricCards
        items={items}
        loading={loadingStats}
        ariaLabel="To and Fro dashboard statistics"
      />
    </div>
  );
}
